const deviceTrackingStatusMapper = {
  toTrackerStatus(status) {
    switch (status) {

      case 1:
        return "configured";

      case 2:
        return "active";

      case 3:
        return "in_use";

      case 4:
        return "extracted";

      case 5:
        return "maintenance";

      case 6:
        return "no_signal";

      case 7:
        return "process_discarted";

      default:
        return "";
    }
  }
};

export default deviceTrackingStatusMapper;